<template>
  <th v-if="!hide" :rowspan="theadRowspan">
    <slot>
      <w-label
        v-if="schema"
        :title="title || schema.title"
        :show-label="showLabel"
        :description="{
          value: description.value === undefined ? schema.description : description.value,
          tooltip: description.tooltip === undefined ? true : description.tooltip,
          htmlContent: description.htmlContent,
          newLine: description.newLine
        }"
        :next-number="nextNumber"
        :bold-label="boldLabel == null ? true : boldLabel"
        :labelFor="'input-' + dataIds.sid"
        :only-description="onlyDescription"
        :autotext="autotext"
      >
        <template v-slot:prepend>
          <slot name="prependlabel" />
        </template>

        <template v-slot:description>
          <slot name="description" />
        </template>

        <template v-slot:append>
          <slot name="appendlabel" />
        </template> </w-label
    ></slot>
  </th>
</template>

<script>
import tableMixin from '../mixins/tableMixin';
import titleMixin from '../mixins/titleMixin';
import wcagMixin from '../mixins/wcagMixin';

export default {
  name: 'w-th',
  mixins: [tableMixin, titleMixin, wcagMixin],
  props: {
    schema: {
      type: Object,
      required: false
    },
    hide: {
      type: Boolean,
      default: false
    }
  }
};
</script>
